export default function Configure($stateProvider) {
	$stateProvider.state('cessions', {
		parent: 'gestion',
		url: '/cessions',
		views: {
			gestion: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
		}
	});

	$stateProvider.state('cessions.list', {
		url: '/list',
		template: '<cessions></cessions>',
		rights: { domain: 'cession', right: 'update' },
		ncyBreadcrumb: {
			label: '{{ "CESSIONS.BREADCRUMBS.CESSIONS_LIST" | translate}}'
		},
		navigation: {
			menu: 'donnees_parametres_parametres',
			translate: 'CESSIONS.BREADCRUMBS.CESSIONS_LIST',
			order: 35
		},
		search: 'CESSIONS.BREADCRUMBS.CESSIONS_LIST'
	});
}

Configure.$inject = ['$stateProvider'];
